import Component from '../core/Component'
import Cookies from 'js-cookie'
import EventBus from '../core/EventBus'
import {EVENTS} from '../core/Events'

export const STATES = {
    ACTIVE: 'is-active',
    AFTER_SWUP: 'is-after-swup'
}

export default class Alert extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            close: null
        }

        this.alertId = null
    }

    prepare() {
        this.alertId = this.element.dataset.alertId
        const alertId = Cookies.get(`cookiesAlert-${this.alertId}`)

        if (!alertId || alertId !== this.alertId) {
            this.ref.close.addEventListener('click', this.handleClick)
            this.show()

            EventBus.on(EVENTS.SWUP_WILL_REPLACE_CONTENT, this.handleSwupWillReplace)
        } else {
            this.selfRemove()
        }
    }

    destroy() {
        EventBus.off(EVENTS.SWUP_WILL_REPLACE_CONTENT, this.handleSwupWillReplace)
    }

    handleSwupWillReplace = () => {
        this.element.classList.add(STATES.AFTER_SWUP)
    }

    handleClick = event => {
        event.preventDefault()
        this.hide()
    }

    show() {
        this.element.classList.add(STATES.ACTIVE)
    }

    hide() {
        this.element.classList.remove(STATES.ACTIVE)

        Cookies.set(`cookiesAlert-${this.alertId}`, this.alertId, {
            expires: 30
        });
    }

    selfRemove() {
        this.destroy()
        this.element.parentNode.removeChild(this.element)
    }
}